import Toggler from '@components/toggle/toggle.view';

export default Toggler;
